import React from 'react'
import { ICONS } from '../../../themes'

// Components
import { Button, Image, Section, Table } from '../../../components'

// Helpers
import {
  formatNumberWithCommaN2Decimal,
  dateMonDayYearTimeFull,
} from '../../../helpers'

const BidHistoryOfSupplier = ({
  toggleModal,
  eventData,
  bidHistory,
  leading,
  userId,
  setBidHistoryId,
}) => {
  return (
    <Section className="auction-log">
      <Section className="history-left">
        <div>
          <Section className="bid-history-title">
            <div className="title">
              <b>Your Bid History</b>
            </div>
          </Section>
          <Section className="bid-history-list">
            <Section className="table-header-freeze-wrapper">
              <Table className="split-row-color">
                <Table.THEAD>
                  <Table.TR className="header">
                    <Table.TH className="history-bidding-no" id="bidding_no">
                      BIDDING NO.
                    </Table.TH>
                    <Table.TH
                      className="history-bidding-amount"
                      id="supplier_name"
                    >
                      TOTAL BIDDING AMOUNT(
                      {eventData && eventData.currency})
                    </Table.TH>
                    <Table.TH
                      className="history-bidding-time"
                      id="bidding_amount"
                    >
                      BIDDING TIME
                    </Table.TH>
                    <Table.TH className="history-view-more" id="bidding_time">
                      VIEW MORE
                    </Table.TH>
                  </Table.TR>
                </Table.THEAD>
                <Table.TBODY>
                  <Section className="list">
                    {bidHistory &&
                      bidHistory.map((value, index) => (
                        <Table.TR key={index}>
                          <Table.TD className="history-bidding-no">
                            {bidHistory.length - index}
                          </Table.TD>
                          <Table.TD className="history-bidding-amount">
                            {value.total
                              ? formatNumberWithCommaN2Decimal(value.total)
                              : 0}
                          </Table.TD>
                          <Table.TD
                            className="history-bidding-time"
                            title={dateMonDayYearTimeFull(value.log_time)}
                          >
                            {dateMonDayYearTimeFull(value.log_time)}
                          </Table.TD>
                          <Table.TD className="history-view-more">
                            <Button
                              className="link"
                              onClick={() => {
                                setBidHistoryId(index)
                                toggleModal('modals-history-of-supplier')
                              }}
                            >
                              <Image src={ICONS['icon-view.svg']} />
                            </Button>
                          </Table.TD>
                        </Table.TR>
                      ))}
                  </Section>
                </Table.TBODY>
              </Table>
            </Section>
          </Section>
        </div>
      </Section>
      <Section className="previous-right">
        <div>
          <Section className="bid-history-title">
            <div className="title">
              <b>Your Previous Bid</b>
              {leading.userID === userId && (
                <Image
                  src={ICONS['icon-hammer-green.svg']}
                  className="hammer-green"
                  style={{ width: 'fit-content' }}
                />
              )}
            </div>
          </Section>
          <Section className="bid-history-list">
            <Section className="table-header-freeze-wrapper">
              <Table className="split-row-color">
                <Table.THEAD>
                  <Table.TR className="header">
                    <Table.TH
                      className="previous-bidding-amount"
                      id="bidding_no"
                    >
                      TOTAL BIDDING AMOUNT(
                      {eventData && eventData.currency})
                    </Table.TH>
                    <Table.TH
                      className="previous-bidding-time"
                      id="supplier_name"
                    >
                      BIDDING TIME
                    </Table.TH>
                  </Table.TR>
                </Table.THEAD>
                <Table.TBODY>
                  <Section className="list">
                    {bidHistory &&
                      bidHistory.map((value, index) => {
                        if (index === 0) {
                          return (
                            <Table.TR key={index}>
                              <Table.TD className="previous-bidding-amount">
                                {value.total
                                  ? formatNumberWithCommaN2Decimal(value.total)
                                  : 0}
                              </Table.TD>
                              <Table.TD
                                className="previous-bidding-time"
                                title={dateMonDayYearTimeFull(value.log_time)}
                              >
                                {dateMonDayYearTimeFull(value.log_time)}
                              </Table.TD>
                            </Table.TR>
                          )
                        }
                        return false
                      })}
                  </Section>
                </Table.TBODY>
              </Table>
            </Section>
          </Section>
        </div>
      </Section>
    </Section>
  )
}

export default BidHistoryOfSupplier
